<div name="navbar">
      <!-- Top Navbar -->
      <header class="sticky top-0 z-30 bg-white dark:bg-slate-900 border-b border-gray-100 dark:border-slate-800" role="banner">
        <div class="flex items-center justify-between h-16 px-4 sm:px-6">
          <div class="flex items-center flex-1">
            <button (click)="toggleSidebar()" class="lg:hidden p-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-800 mr-3 btn-press" aria-label="Toggle sidebar menu" aria-expanded="false">
              <i class="fas fa-bars text-lg" aria-hidden="true"></i>
            </button>
            
            <!-- Breadcrumbs -->
            <div name="breadcrumbs">
              <nav class="hidden sm:flex items-center space-x-2 text-sm pb-0">
                <a [routerLink]="['/dashboard']" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                  <i class="fas fa-home"></i>
                </a>
                @for (breadcrumb of breadcrumbs; track breadcrumb.url; let isLast = $last) {
                  <i class="fas fa-chevron-right text-gray-300 dark:text-gray-600 text-xs"></i>
                  @if (!isLast) {
                    <a [routerLink]="breadcrumb.url" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">{{ breadcrumb.label }}</a>
                  } @else {
                    <span class="text-gray-600 dark:text-gray-300 font-medium">{{ breadcrumb.label }}</span>
                  }
                }
              </nav>
            </div>
            
          </div>
          
          <!-- Navbar Right Actions -->
          <div class="flex items-center space-x-2 sm:space-x-3">
            @for (action of navbarActions; track action) {

              @if (action === 'language' && !isHubSpotShell) {
                <div class="hidden lg:block">
                  <app-i18n></app-i18n>
                </div>
              }

              <!-- @if (action === 'dark-mode') {
                <button (click)="toggleDarkMode()" class="w-9 h-9 flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors btn-press" aria-label="Toggle dark mode">
                  <i class="fas fa-moon text-lg dark:hidden" aria-hidden="true"></i>
                  <i class="fas fa-sun text-lg hidden dark:block text-yellow-500" aria-hidden="true"></i>
                </button>
              } -->

            }
          </div>
        </div>
      </header>
    </div>